import React from 'react'
import { Link } from 'gatsby'
import ESW_CLASSNAMES from '../esw/classnames'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Carousel from 'react-bootstrap/Carousel'

import AddToCart from './add-to-cart'
import PriceDisplay from './price-display'
import useGetAllProduct from '../hooks/useGetAllProduct'
// BG
import springbg from '../images/spring-sale-2025/air-banner-02-bg-B.png'
import subfactorybg from '../images/homepage/subfactory-bg.png'
import timewarpbg from '../images/homepage/timewarp-bg.png'
import creativefx2bg from '../images/homepage/creativefx-2-bg.png'
import softclipperbg from '../images/homepage/softclipper-bg.png'
import jurabg from '../images/homepage/jura-bg.png'
import spritebg from '../images/homepage/sprite-bg.png'
import delayprobg from '../images/homepage/delay-pro-bg.png'
import flexbeatbg from '../images/homepage/flex-beat-bg.png'
import loflydirtbg from '../images/homepage/lo-fly-dirt-bg.png'
// GUI
import springgui from '../images/spring-sale-2025/acfxc2-new-airstore-banner-gui.png'
import subfactorygui from '../images/homepage/subfactory-gui.png'
import timewarpgui from '../images/homepage/timewarp-gui.png'
import creativefx2gui from '../images/homepage/creativefx-2-gui.png'
import softclippergui from '../images/homepage/softclipper-gui.png'
import juragui from '../images/homepage/jura-gui.png'
import spritegui from '../images/homepage/sprite-gui.png'
import delayprogui from '../images/homepage/delay-pro-gui.png'
import flexbeatgui from '../images/homepage/flex-beat-gui.png'
import loflydirtgui from '../images/homepage/lo-fly-dirt-gui.png'
// SVG
import eyeblack from '../images/svgs/eye-icon-black.svg'
import eyewhite from '../images/svgs/eye-icon-white.svg'

export default function HardCodedProductCarousel() {
    const allProduct = useGetAllProduct()
    const data = [
        {
            sku: 'XSLFD',
            background: loflydirtbg,
            gui: loflydirtgui,
            description: <>Vintage Sounds for the Modern Musician</>,
            classNames: {
                color: 'text-white',
                discover: 'text-white border-white',
            },
            eyeicon: eyewhite,
        },
        {
            sku: 'ARSF1',
            background: subfactorybg,
            gui: subfactorygui,
            description: <>Take Your Bass Lines Deeper</>,
            classNames: {
                color: 'text-white',
                discover: 'text-white border-white',
            },
            eyeicon: eyewhite,
        },
        {
            sku: 'WWT26',
            background: timewarpbg,
            gui: timewarpgui,
            description: <>The only ARP 2600 emulator endorsed by its original inventor.</>,
            classNames: {
                color: 'text-white',
                discover: 'text-white border-white',
            },
            eyeicon: eyewhite,
        },
        {
            sku: 'ARCC4',
            background: creativefx2bg,
            gui: creativefx2gui,
            description: <>A curated collection of 40 high quality audio tools, including 12 new plugins with a pedigree in professional music-making environments.</>,
            classNames: {
                color: 'text-white',
                discover: 'text-white border-white',
            },
            eyeicon: eyewhite,
        },
        {
            sku: 'ARSC1',
            background: softclipperbg,
            gui: softclippergui,
            description: <>Give your tracks that loud, yet clean, release ready sound.</>,
            classNames: {
                color: 'text-white',
                discover: 'text-white border-white',
            },
            eyeicon: eyewhite,
        },
        {
            sku: 'ARJR1',
            background: jurabg,
            gui: juragui,
            description: <>Jura is the classic synth for a modern music<br /> production studio.</>,
            classNames: {
                color: 'text-white',
                discover: 'text-white border-white',
            },
            eyeicon: eyewhite,
        },
        {
            sku: 'ARSP2',
            background: spritebg,
            gui: spritegui,
            description: <>A powerful multi-effects plugin, that is as simple,<br /> or as complex as you like</>,
            classNames: {
                color: 'text-black',
                discover: 'text-black border-black',
            },
            eyeicon: eyeblack,
        },
        {
            sku: 'ARDL2',
            background: delayprobg,
            gui: delayprogui,
            description: <>Can Your Delay Plugin Do This?</>,
            classNames: {
                color: 'text-white',
                discover: 'text-white border-white',
            },
            eyeicon: eyewhite,
        },
        {
            sku: 'AKFB0',
            background: flexbeatbg,
            gui: flexbeatgui,
            description: <>A powerful multi-effects plugin, that is as simple,<br /> or as complex as you like</>,
            classNames: {
                color: 'text-white',
                discover: 'text-white border-white',
            },
            eyeicon: eyewhite,
        },
    ]
    return (
        <Carousel className='homepage px-md-5 px-sm-4 px-3 pt-md-5 pt-sm-4 pt-3 bg-light' interval={null} touch wrap>

{/* <Carousel.Item>
                <Container className={`flex-shrink-0 shadow mb-5`} fluid style={{
                    backgroundImage: `url(${springbg})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: '',
                    borderRadius: 16,
                }}>
                    <Container className='p-3'>
                        <Row className='justify-content-between align-items-center' style={{ minHeight: 560 }}>
                            <Col className='d-md-none py-4'>
                                <Link to={`/sale`}>
                                    <img src={springgui} alt='' className='w-100' />
                                </Link>
                            </Col>
                            <Col md>
                                <Link to={`/sale`}>
                                    <h2 className={`text-uppercase text-white`} style={{marginBottom: 24, fontSize: 48 }}>
                                        Spring Sale
                                    </h2>
                                    <h4 className={'text-white text-uppercase ff-secondary'} style={{ fontSize: 16, marginBottom: 24, }}>
                                        More Than 100 <span className='fw-normal'>Music Production Tools</span>
                                    </h4>
                                </Link>
                                <div className="d-flex flex-column flex-sm-row mb-5" style={{ gap: 20 }}>
                                    <Link
                                        to={`/sale`}
                                        className='fw-medium btn flex-center gap-1 text-black text-uppercase bg-primary border border-primary shadow'
                                        style={{ width: 183, padding: '8px 0px' }}
                                    >
                                        <img src={eyeblack} alt='' />
                                        Explore Offers
                                    </Link>
                                </div>
                            </Col>
                            <Col className='d-none d-md-block'>
                                <Link to={`/sale`}>
                                    <img src={springgui} alt='' className='w-100' />
                                </Link>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </Carousel.Item> */}
            
            {data.map(({ sku }) => {
                const product = allProduct.find(({ node }) => node.sku === sku)
                const { background, gui, description, classNames, eyeicon } = data.find(_ => _.sku === sku)

                return <Carousel.Item key={`hardcoded-product-carousel-${product?.node?.id}`}>
                    <Container className={`flex-shrink-0 shadow mb-5`} fluid style={{
                        backgroundImage: `url(${background})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: 16,
                    }}>
                        <Container className='p-3'>
                            <Row className='justify-content-between align-items-center' style={{ minHeight: 560 }}>
                                <Col className='d-md-none py-4'>
                                    <Link to={`/${product.node.shop_categories[0].slug}/${product.node.slug}`}>
                                        <img src={gui} alt='' className='w-100' />
                                    </Link>
                                </Col>
                                <Col md>
                                    <Link to={`/${product.node.shop_categories[0].slug}/${product.node.slug}`} className={`${classNames.color}`}>
                                        <h2 className={`${classNames.color} text-uppercase`}>{product.node.product_name}</h2>
                                    </Link>
                                    <p className={`${classNames.color} text-uppercase`}>{product.node.shop_categories[0].name}</p>
                                    <p className={`${classNames.color}`}>{description}</p>
                                    <PriceDisplay
                                        product={product?.node}
                                        style={{ fontSize: 16 }}
                                        className={`${classNames.color} fw-semibold d-flex align-items-center gap-2`}
                                        eswPriceClassName={ESW_CLASSNAMES.PAGE_PRICE}
                                        eswPriceStrikedClassname={ESW_CLASSNAMES.PAGE_PRICE}
                                    />
                                    <div className="d-flex flex-column flex-sm-row mb-5" style={{ gap: 20 }}>
                                        <Link
                                            to={`/${product.node.shop_categories[0].slug}/${product.node.slug}`}
                                            className={`${classNames.discover} fw-medium btn bg-transparent border flex-center gap-1 shadow`}
                                            style={{ width: 183, padding: '12px 0' }}
                                        >
                                            <img src={eyeicon} alt='' />
                                            DISCOVER
                                        </Link>
                                        <AddToCart
                                            product={product.node}
                                            className='fw-medium btn flex-center gap-1 text-black bg-primary border border-primary shadow'
                                            style={{ width: 183, padding: '12px 0' }}
                                        />
                                    </div>
                                </Col>
                                <Col className='d-none d-md-block'>
                                    <Link to={`/${product.node.shop_categories[0].slug}/${product.node.slug}`}>
                                        <img src={gui} alt='' className='w-100' />
                                    </Link>
                                </Col>
                            </Row>
                        </Container>
                    </Container>
                </Carousel.Item>
            })}
        </Carousel>
    )
}
